import { render, staticRenderFns } from "./soft.vue?vue&type=template&id=35b3844e&"
import script from "./soft.vue?vue&type=script&lang=js&"
export * from "./soft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports